import type { ButtonHTMLAttributes, ComponentType, HTMLAttributes } from 'react'
import styled from 'styled-components'

const BadgeCell = styled.span`
  align-items: center;
  color: ${({ theme }) => theme.color.neutral.color5};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 28px;
` as ComponentType<HTMLAttributes<HTMLSpanElement>>

const LabelCell = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: 400;
` as ComponentType<HTMLAttributes<HTMLSpanElement>>

const MenuPanel = styled.div`
  background: ${({ theme }) => theme.color.neutral.color11};
  border-radius: ${({ theme }) => theme.properties.borderRadius.small};
  border: 1px solid ${({ theme }) => theme.color.neutral.color7};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  min-width: 220px;
  padding: 4px;
` as ComponentType<HTMLAttributes<HTMLDivElement>>

const MenuRow = styled.button<{ $selected: boolean; $selectedBg: string }>`
  align-items: center;
  background: ${({ $selected, $selectedBg }) => ($selected ? $selectedBg : 'transparent')};
  border-radius: 6px;
  border: none;
  color: ${({ theme }) => theme.color.neutral.color3};
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 8px;
  padding: 8px 10px;
  text-align: left;
  width: 100%;

  &:hover {
    background: ${({ $selected, $selectedBg, theme }) =>
      $selected ? $selectedBg : theme.color.neutral.color8};
  }
` as ComponentType<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    $selected: boolean
    $selectedBg: string
  }
>

export { BadgeCell, LabelCell, MenuPanel, MenuRow }
